import axios, { type AxiosInstance, type CreateAxiosDefaults } from "axios";

// One shared axios setup, reused by every axios instance in the app (browser and
// server) instead of each file/component calling axios.create() with its own
// ad-hoc config. validateStatus is disabled everywhere so callers inspect
// status/data themselves instead of dealing with thrown AxiosError on non-2xx
// responses.
export function createHttpClient(config: CreateAxiosDefaults = {}): AxiosInstance {
  return axios.create({
    validateStatus: () => true,
    ...config,
  });
}
